export const PropertyActionTypes = {
  SET_PROPERTY: '[Property] Set Property',
  FETCH_IN_PROGRESS: '[Property] Fetch In Progress',
  FETCH_FINISHED: '[Property] Fetch Finished',
  TOUCH_PROPERTY: '[Property] Touch Property',
};
